<template>
  <span>{{prettyFilename}}</span>
</template>

<script>

export default {
  name: 'PrettyFilename',
  props: {
    filename: String,
  },
  computed: {
    // un accesseur (getter) calculé
    prettyFilename() {
      const index = this.filename.lastIndexOf('.')
      if (index > 15) {
        const extension = this.filename.substring(index + 1, this.filename.length)
        const shortFilename = this.filename.substring(0, 12)
        return `${shortFilename}...${extension}`
      }
      return this.filename
    },
  },
}
</script>
